import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="flex h-screen overflow-hidden bg-[#020617]">
      <Sidebar />
      <main className="flex-1 overflow-auto p-6 lg:p-8" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
}
